// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_YEAR_DESCRIPTION_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_DESCRIPTION_LOADED() {
      return {
        isLoading: false,
        data: action.micYearDescription
      };
    },
    MIC_YEAR_DESCRIPTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYearDescription.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
